module.exports = __webpack_public_path__ + "img/us-oc.69634f28.png";